<div class="input-group flex-nowrap mb-3">
        <span class="input-group-text">{{label}}</span>
    <input [type]="type" placeholder="{{placeholder}}" [formControl]="convertToFormControl(ngControl.control)"
        class="form-control">
</div>
